import { IconButton, InputAdornment, styled, TextField } from "@mui/material";
import React, { useRef } from "react";
import {ReactComponent as UploadIcon} from "../../assets/icons/upload.svg"

const UploadImageInput = ({ fileName, handleFileChange }) => {
    const fileInputRef = useRef(null);
    const handleClick = () => {
        // Trigger the file input click via the ref
        fileInputRef.current.click();
      };

const onChange=(e)=>{
    const file=e.target.files[0];
    handleFileChange(file)
}

  return (
    <>
    <TextField
      fullWidth
      label="Upload File"
    //   disabled
    type="button"
      value={fileName}
      onClick={handleClick} 
      inputProps={{
        style:{
            textAlign:"left"
        }
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
              <UploadIcon style={{cursor: "pointer"}} />
          </InputAdornment>
        ),
      }}
    />
      <input type="file" ref={fileInputRef} hidden onChange={onChange} />
      </>
  );
};

export default UploadImageInput;
